import styled from 'styled-components';
import theme from 'configs/theme';

const RoutersWrapper = styled.div`
  .ant-form-item {
    margin-bottom: 10px;
    text-align: left;
  }

  .link-text {
    cursor: pointer;
    color: ${theme.palette.primaryColor}
  }
`;

export default RoutersWrapper;
